import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);

    const prevTitle = document.title;
    document.title = "Page Not Found | Garage Kings YEG";

    const setMeta = (selector: string, attr: string, value: string) => {
      let el = document.head.querySelector<HTMLMetaElement>(selector);
      const created = !el;
      if (!el) {
        el = document.createElement("meta");
        const [a, v] = selector.replace(/[\[\]"]/g, "").split("=");
        el.setAttribute(a, v);
        document.head.appendChild(el);
      }
      const prev = el.getAttribute(attr);
      el.setAttribute(attr, value);
      return () => {
        if (created) el!.remove();
        else if (prev !== null) el!.setAttribute(attr, prev);
      };
    };

    const url = `https://garagekingsyeg.com${location.pathname}`;
    const restorers = [
      setMeta('meta[name="description"]', "content", "The page you're looking for doesn't exist. Return to Garage Kings YEG for Edmonton junk removal and garage resets."),
      setMeta('meta[property="og:title"]', "content", "Page Not Found | Garage Kings YEG"),
      setMeta('meta[property="og:description"]', "content", "The page you're looking for doesn't exist."),
      setMeta('meta[property="og:url"]', "content", url),
      setMeta('meta[name="twitter:title"]', "content", "Page Not Found | Garage Kings YEG"),
      setMeta('meta[name="twitter:description"]', "content", "The page you're looking for doesn't exist."),
    ];

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const prevCanonical = canonical?.getAttribute("href") ?? null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    let robots = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    const robotsCreated = !robots;
    const prevRobots = robots?.getAttribute("content") ?? null;
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");

    return () => {
      document.title = prevTitle;
      restorers.forEach((r) => r());
      if (prevCanonical !== null) canonical!.setAttribute("href", prevCanonical);
      if (robotsCreated) robots!.remove();
      else if (prevRobots !== null) robots!.setAttribute("content", prevRobots);
    };
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
